import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { GET_REPORTS_DATA } from '@custom/constant';
import { ReportParams } from '@custom/Utils/constants/interfaces';

export const getAllReport = createAsyncThunk(
  'reports/postReportData',
  async (params: ReportParams, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem('token') || localStorage.getItem('token');
      const response = await axios.post(
        `${GET_REPORTS_DATA}`,
        params, // using params here
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Error posting report data');
    }
  }
);
